import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";

import cmn1 from "../../Images/pawana/cmn1.jpg";
import cmn2 from "../../Images/pawana/cmn2.jpg";
import cmn3 from "../../Images/pawana/cmn3.jpg";
import tnt1 from "../../Images/pawana/TentStay/tnt1.jpg";
import triangle1 from "../../Images/pawana/TriangleStay/1.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Tikona Fort with Pawana Camping Sunset",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:20 AM", activity: "Pick-up at Swargate." },
      { time: "05:40 AM", activity: "Pick-up at Vanaj Metro Station." },
      { time: "05:55 AM", activity: "Pick-up at Wakad Bridge." },
      { time: "06:10 AM", activity: "Pick-up at Hinjwadi." },
      {
        time: "09:30 AM",
        activity: "Reach the base village and have Breakfast.",
      },
      {
        time: "10:00 AM",
        activity: "start the trek to Tikona Fort.",
      },
      {
        time: "12:00 PM",
        activity:
          "Reach the fort top and soak in the panoramic views of the surrounding ranges.",
      },
      {
        time: "02:00 PM",
        activity:
          "Begin the descent and have a Lunch break at the base village.",
      },
      {
        time: "03:30 PM",
        activity: "Arrive at Pawana.",
      },
      {
        time: "05:30 PM",
        activity: "Enjoy the sunset, music, and a relaxed evening by the lake.",
      },
      {
        time: "06:30 PM",
        activity: "Start the return journey to Pune.",
      },
      { time: "10:00 PM", activity: "Approx. arrival back in Pune." },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "This adventure blends a moderate fort trek with a peaceful evening at Pawana, making it perfect for both trekkers and campers.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Veg & Non-Veg Lunch",
      "🍲 Dinner & Evening Tea",
      "🧭 Experienced Trek Leader & Local Guide",
      "🩺 Basic First Aid & Hydration Support",
      "🏕️ Camping Setup & Sunset Viewpoint Access",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Personal insurance or medical expenses.",
      "Any emergency evacuation charges.",
      "Photography or videography permits (if applicable).",
    ],
    verticalCards: [
      { title: "Tikona Fort Trail", image: cmn1 },
      { title: "Pawana Sunset View", image: cmn2 },
      { title: "Camping Setup", image: tnt1 },
      { title: "Evening by the Lake", image: cmn3 },
      { title: "Campfire Night", image: triangle1 },
    ],
    trekData: [
      {
        name: "Tikona Fort with Pawana Camping Sunset",
        image: cmn1,
        info: "Experience the thrill of climbing Tikona Fort, one of the most iconic forts near Pune, combined with a serene sunset camping experience at Pawana. The trek is a perfect mix of adventure, history, and nature, offering a gradual climb, wide panoramic views, and a peaceful evening by the lake. After the fort visit, the journey continues to Pawana for a sunset view, campfire, dinner, and an overnight stay under the stars, making it one of the most memorable weekend getaways for trekkers and nature lovers.",
      },
    ],
    faq: [
      {
        question: "What is unique about this experience?",
        answer:
          "It combines a classic fort trek with a camping night at Pawana, giving you both adventure and relaxation in one trip.",
      },
      {
        question: "Is the trek beginner-friendly?",
        answer:
          "Yes, the trek is suitable for beginners with basic fitness, though some steep stretches require steady footing.",
      },
      {
        question: "Is camping included?",
        answer:
          "Yes, camping setup, dinner, and sunset access at Pawana are included in the package.",
      },
      {
        question: "Should I carry extra warm clothes?",
        answer:
          "Yes, carrying a light shawl or jacket is recommended for the evening and night camping experience.",
      },
    ],
  },
];

const TikonaFortPawanaCampingSunset = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Tikona Fort with Pawana Camping Sunset"
          location="Tikona Fort & Pawana"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default TikonaFortPawanaCampingSunset;
